import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_users_admin = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/`,
        method: "GET"
    }))
}

export const create_new_user = async (userData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/`,
        method: "POST",
        body: JSON.stringify(userData)
    }))
}

export const update_user = async (user_id, userData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/id/${user_id}`,
        method: "PUT",
        body: JSON.stringify(userData)
    }))
}

export const delete_user = async (user_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/id/${user_id}`,
        method: "DELETE"
    }))
}

export const get_user_by_id = async (user_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/id/${user_id}`,
        method: "GET"
    }))
}

export const disable_user_2fa = async (user_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/id/${user_id}/disable-2fa`,
        method: "POST",
        credentials: "include"
    }))
}

export const load_user_home = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/users/home`,
        method: "GET"
    }))
}
